import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/system/Stack";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
import React from "react";
const SkillsTabPanel = (props) => {
    const { title, text, image, dynamicList } = props;
    return (_jsxs(Stack, { direction: {
            xs: "column",
            md: "row",
        }, spacing: 5, sx: {
            width: "100%",
        }, children: [_jsxs(Stack, { spacing: 2, sx: {
                    width: "100%",
                    backgroundColor: "#F6F6F9",
                    p: 5,
                }, children: [_jsxs(Stack, { spacing: 1.5, children: [_jsx(Typography, { variant: "subtitle1", component: "h2", children: title }), _jsx(Typography, { variant: "body1", children: text })] }), _jsxs(Stack, { spacing: 1.5, children: [_jsx(Typography, { variant: "subtitle1", component: "h3", children: "Outils & technos" }), _jsx(Stack, { direction: "row", spacing: 1.5, useFlexGap: true, sx: {
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                }, children: dynamicList?.map((item, index) => (_jsxs(Stack, { direction: "row", spacing: 1.5, sx: {
                                        alignItems: "center",
                                        border: "1px solid",
                                        borderColor: "border.grey",
                                        padding: 1.5,
                                    }, children: [_jsx(Box, { sx: {
                                                width: "auto",
                                                height: 20,
                                            }, children: _jsx(ImageContainer, { ratio: "", children: item.image }) }), _jsx(Typography, { variant: "body2", children: item.title })] }, (item.title || "") + index))) })] })] }), _jsx(Stack, { sx: {
                    width: 160,
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "background.main",
                    display: { xs: "none", md: "flex" },
                    p: 5,
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        backgroundImage: "url('/pattern-contact-left.svg')",
                        backgroundPosition: "left 0px top -80px",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        inset: 0,
                    },
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        backgroundImage: "url('/pattern-contact-right.svg')",
                        backgroundPosition: " right 0px bottom -48px",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        inset: 0,
                    },
                }, children: image && (_jsx(Box, { sx: {
                        width: 50,
                        height: "auto",
                        zIndex: 2,
                    }, children: _jsx(ImageContainer, { ratio: "", children: image }) })) })] }));
};
export default SkillsTabPanel;
